import { Helmet } from "react-helmet-async";

const BASE_URL = typeof window !== "undefined" ? window.location.origin : "https://monarch-power.preview.emergentagent.com";

export function SEO({ title, description, keywords, pathname, schemaType = "ProfessionalService", image = "/monarch-logo-transparent.png" }) {
  const canonical = `${BASE_URL}${pathname}`;
  const imageUrl = image.startsWith("http") ? image : `${BASE_URL}${image}`;
  const schema = {
    "@context": "https://schema.org",
    "@type": schemaType,
    name: "Monarch Solar & Roofing Solutions",
    url: canonical,
    description,
    image: imageUrl,
    telephone: "800-281-2717",
    areaServed: ["Los Angeles", "California"],
    address: {
      "@type": "PostalAddress",
      streetAddress: "515 S Flower St, 18th Floor",
      addressLocality: "Los Angeles",
      addressRegion: "CA",
      postalCode: "90071",
      addressCountry: "US",
    },
  };

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta content={description} name="description" />
      <meta content={keywords.join(", ")} name="keywords" />
      <link href={canonical} rel="canonical" />

      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content="website" property="og:type" />
      <meta content={canonical} property="og:url" />
      <meta content={imageUrl} property="og:image" />
      <meta content="Monarch Solar & Roofing Solutions" property="og:site_name" />

      <meta content="summary_large_image" name="twitter:card" />
      <meta content={title} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content={imageUrl} name="twitter:image" />

      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}